import { Root as VisuallyHiddenRoot } from "@radix-ui/react-visually-hidden"

export const VisuallyHidden = VisuallyHiddenRoot
